import { ContributorAssignmentAndEntry } from '../../../model/product/contributors';
import { WizardFeatureState } from '../../../model/product/wizard';

export function allContributors(state: WizardFeatureState, newAssignments: ContributorAssignmentAndEntry[]) {
  const newContributors = newAssignments.filter(({ id }) =>
    state.value.contributors.every(({ id: knownId }) => knownId !== id),
  );

  const noDuplicatesNewContributors = newContributors.filter(
    ({ id }, index) => index === newContributors.findIndex(({ id: innerId }) => id === innerId),
  );

  return noDuplicatesNewContributors.length === 0
    ? state.value.contributors
    : state.value.contributors.concat(noDuplicatesNewContributors.map((c) => c.contributor));
}
